module.exports = __webpack_public_path__ + "img/ic-smartphone.30355ced.svg";